import React, { useEffect, useState } from 'react'
import styles from '../CreateTripActivityPage/CreateTripActivityPage.module.scss'
import { Grid, Paper } from '@mui/material'
import { useLocation, useParams } from 'react-router-dom'
import CreateAccommodationForm from './CreateAccommodationForm'
import tripService from '../../../supabaseServices/TripService'
import { defaultFormatDate } from '../../../utils/format'

interface LocationState {
  accommodation?: {
    id: number
    uuid: string
    name: string
    physical_address: string
    access_instructions: string
    wifi_info: string
    type: string
    bedrooms: number
    bathrooms: number
    max_capacity: number
    check_in: string
    check_out: string
    price: number
    currency: string
    listing_link: string
    location_uuid: string
    locations?: {
      latitude: string
      longitude: string
      address: string
    }
  }
}

const CreateAccommodationPage: React.FC = () => {
  const location = useLocation<LocationState>()
  const accommodationState = location.state?.accommodation
  const [tripData, setTripData] = useState<any | undefined>(undefined)
  const { tripId } = useParams<{ tripId: string }>()

  useEffect(() => {
    const fetchTripData = async () => {
      try {
        const trip = await tripService.getTripByUUID(tripId)
        if (trip) {
          setTripData(trip)
        }
      } catch (error) {
        console.error('Error fetching trip data:', error)
      }
    }

    fetchTripData()
  }, [tripId])

  const convertedAccommodation = accommodationState
    ? {
        ...accommodationState,
        check_in: accommodationState.check_in ? new Date(accommodationState.check_in) : null,
        check_out: accommodationState.check_out ? new Date(accommodationState.check_out) : null,
      }
    : undefined

  return (
    <main>
      <Grid container spacing={0} py={2}>
        <Grid item xs={12}>
          <div className={styles.mainWrapper}>
            <div className={styles.headerWrapper}>
              <h1>{accommodationState ? 'Edit Accommodation' : 'Add Accommodation'}</h1>
              {tripData && (
                <div className={styles.papersWrap}>
                  <div className={styles.paperItem}>
                    Trip name
                    <Paper elevation={3}>
                      <div className={styles.paper}>{tripData.trip_name}</div>
                    </Paper>
                  </div>
                  <div className={styles.paperItem}>
                    Location
                    <Paper elevation={3}>
                      <div className={styles.paper}>{tripData.location}</div>
                    </Paper>
                  </div>
                  <div className={styles.paperItem}>
                    Start Date
                    <Paper elevation={3}>
                      <div className={styles.paper}>{defaultFormatDate(tripData.start_date)}</div>
                    </Paper>
                  </div>
                  <div className={styles.paperItem}>
                    End Date
                    <Paper elevation={3}>
                      <div className={styles.paper}>{defaultFormatDate(tripData.end_date)}</div>
                    </Paper>
                  </div>
                </div>
              )}
            </div>
            <CreateAccommodationForm tripId={tripId} initialValues={convertedAccommodation} />
          </div>
        </Grid>
      </Grid>
    </main>
  )
}

export default CreateAccommodationPage
